// import React from 'react';
// import './Button.css';

// const Button = ({ text, onClick, type = 'button', className}) => {
//   return (
//     <button className={`btn ${className}`} type={type} onClick={onClick}>
//       {text}
//     </button>
//   );
// };

// export default Button;

import React from "react";
import { Button } from "antd";
import "./Button.css";
const CustomButton = ({ variant = "primary",className = "", children, onClick, ...props }) => {
  return (
    <Button
     onClick={onClick}
     className={`custom-btn ${variant} ${className}`}
      {...props}
    >
      {children}
    </Button>
  );
};
export default CustomButton;
